import { AfterViewInit, ChangeDetectionStrategy, Component, Input, input, OnInit } from '@angular/core';
import { ContentBlock } from '../../models';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { JsonPipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-content-block-base',
    imports: [JsonPipe],
    templateUrl: './content-block-base.component.html',
    styleUrl: './content-block-base.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockBaseComponent {
  block = input.required<ContentBlock>();
  index = input.required<number>();
  cookiePreferences = input<CookiePreferences>();

  isDevMode = !environment.production;
}
